import _ from 'lodash';
export const bookingRouteSteps = [
  {
    path: "/register-room",
    step: 1
  },
  {
    path: "/booking-calendar",
    step: 2
  },
  {
    path: "/register-option",
    step: 3
  },
  {
    path: "/booking-information",
    step: 4
  },
  {
    path: "/finish-register-room",
    step: 5
  }
];

export const reBookingRouteSteps = [
  {
    path: "/rebook-overview",
    step: 1
  },
  {
    path: "/booking-calendar",
    step: 2
  },
  {
    path: "/booking-information",
    step: 3
  },
  {
    path: "/finish-register-room",
    step: 4
  }
];

export const getStepByPath = (arr, path) => {
  return _.get(_.find(arr, (t) => t.path === path), 'step', 0);
};

export const getPathByStep = (arr, step) => {
  return _.get(_.find(arr, (t) => t.step === step), 'path', '');
};

export const setStepStorageByPath = (path, isReBooking = false) => {
  const bookingNumber: any = isReBooking || localStorage.getItem('_bookingNumber');
  if (bookingNumber) {
    localStorage.setItem('_bookingStep', '0');
    localStorage.setItem('_reBookingStep', getStepByPath(reBookingRouteSteps, path));
  } else {
    localStorage.setItem('_bookingStep', getStepByPath(bookingRouteSteps, path));
    localStorage.setItem('_reBookingStep', '0');
  }
};
